import script from "./City.vue?vue&type=script&setup=true&lang=js"
export * from "./City.vue?vue&type=script&setup=true&lang=js"

import "./City.vue?vue&type=style&index=0&id=6de576f1&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de576f1"]])

export default __exports__